import HomeLayout from "./_homeLayout";

export default function Index(props) {
  let Miasto = props.miasto;
  let Podatek = props.podatek;

  return <HomeLayout miasto={Miasto} podatek={Podatek}></HomeLayout>;
}
